// Carrier login page that reuses the <Login /> component,
// switching behavior via the "realm" prop.

import React from 'react';
import Login from '../../components/login/login';

export default function CarrierLoginPage() {
  // For the carrier portal, we pass realm="carrier"
  return <Login realm="carrier" />;
}
